// Fluxo (Chat 3.0, item 15 · G1): tela de criar o administrador
// (fluxo/app/views/installation/onboarding/index.html.erb). Estilo proprio e o
// comportamento da senha: mostrar/ocultar, barra de forca e "Criando...".
import '../dashboard/assets/scss/fluxo-onboarding.scss';
import {
  forcaDaSenha,
  NOMES_DA_FORCA,
  REGRAS,
  regrasDaSenha,
  senhaValida,
} from '../dashboard/helper/fluxo/forcaDaSenha';

// Mensagem do navegador quando a pessoa tenta enviar sem cumprir as regras.
const SENHA_INCOMPLETA = 'A senha ainda não cumpre as regras abaixo do campo.';

const textoDosInvalidos = invalidos =>
  `Sem acento, ç ou emoji: troque ${invalidos.map(c => `“${c}”`).join(', ')}.`;

const iniciar = () => {
  const senha = document.querySelector('[data-fxo-senha]');
  const olho = document.querySelector('[data-fxo-olho]');
  const barra = document.querySelector('[data-fxo-forca]');
  const nivel = document.querySelector('[data-fxo-nivel]');
  const form = document.querySelector('[data-fxo-form]');
  const botao = document.querySelector('[data-fxo-enviar]');
  const textoDoBotao = document.querySelector('[data-fxo-enviar-texto]');
  const regras = document.querySelector('[data-fxo-regras]');
  const invalidos = document.querySelector('[data-fxo-invalidos]');

  if (senha && olho) {
    olho.addEventListener('click', () => {
      const mostrar = senha.type === 'password';
      senha.type = mostrar ? 'text' : 'password';
      olho.setAttribute('aria-pressed', String(mostrar));
      olho.setAttribute(
        'aria-label',
        mostrar ? 'Ocultar senha' : 'Mostrar senha'
      );
    });
  }

  // Checklist ao vivo + barra + bloqueio do envio (setCustomValidity: o
  // navegador nao envia e mostra a mensagem em portugues).
  const atualizarSenha = () => {
    const valor = senha.value;
    const estado = regrasDaSenha(valor);
    if (barra && nivel) {
      const n = forcaDaSenha(valor);
      barra.dataset.nivel = String(n);
      nivel.dataset.nivel = String(n);
      nivel.textContent = NOMES_DA_FORCA[n];
    }
    if (regras) {
      REGRAS.forEach(regra => {
        const item = regras.querySelector(`[data-regra="${regra}"]`);
        if (item) item.dataset.ok = String(estado[regra]);
      });
    }
    if (invalidos) {
      invalidos.hidden = !estado.invalidos.length;
      invalidos.textContent = estado.invalidos.length
        ? textoDosInvalidos(estado.invalidos)
        : '';
    }
    senha.setCustomValidity(
      !valor || senhaValida(valor) ? '' : SENHA_INCOMPLETA
    );
  };

  if (senha) {
    senha.addEventListener('input', atualizarSenha);
    // Tentou enviar sem cumprir: o que falta fica vermelho.
    senha.addEventListener('invalid', () => {
      if (regras) regras.dataset.tentou = 'true';
    });
    atualizarSenha();
  }

  if (form && botao && textoDoBotao) {
    form.addEventListener('submit', evento => {
      // Guarda extra (navegador sem validacao nativa): nao envia incompleta.
      if (senha && !senhaValida(senha.value)) {
        evento.preventDefault();
        if (regras) regras.dataset.tentou = 'true';
        senha.focus();
        return;
      }
      botao.disabled = true;
      botao.dataset.enviando = 'true';
      textoDoBotao.textContent = 'Criando…';
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', iniciar);
} else {
  iniciar();
}
